import { css, styled } from 'styled-components';

import {
    CommonAction,
    floorGameDuration as duration,
    floorGameEasing as easing,
    recipesCommonAction,
    styledInteraction,
} from '@pkg/primitives';

export const Wrapper = styled.div`
    z-index: 0;
    position: relative;
    width: 100%;
    min-height: 240px;
    background: linear-gradient(206deg, #323232, #404148 20%, #242424 75%);
    border-radius: 10px;
`;

export const Interior = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 6px;
    position: relative;
`;

export const AssetFrame = styled.div`
    position: relative;
    --overlay-opacity: 0;

    &:hover {
        --overlay-opacity: 1;
    }

    &:active {
        --overlay-opacity: 0.8;
    }

    // Hover overlay
    &::after {
        ${styledInteraction.interactionDisable};
        content: '';
        z-index: 2;
        position: absolute;
        inset: 0;
        border-radius: 10px;
        background-color: rgb(0, 0, 0, 0.4);
        box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);
        opacity: var(--overlay-opacity);
        transition: opacity ${duration.normal}ms ${easing.cubic};
    }
`;

export const AssetAction = styled(CommonAction)`
    ${recipesCommonAction.essential};
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;

    // Fix for short videos
    > video {
        height: 100%;
        // Reset for FireFox
        outline: none;
    }
`;

export const OptionsActionWrapper = styled.div`
    z-index: 3;
    position: absolute;
    top: 0;
    right: 0;
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 6px;
`;

export const TitleGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
`;

export const Title = styled.div`
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.24px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SubTitle = styled.div`
    color: rgba(255, 255, 255, 0.5);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 12px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.24px;
`;

export const RhythmGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
`;

export const Label = styled.div`
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: -0.36px;
`;

export const Score = styled.div`
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 120%;
`;

export const YatBox = styled.div`
    width: 100%;
    aspect-ratio: 1/1;

    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    background: linear-gradient(107deg, #18171c 35.22%, #241d56 76.66%);
`;

export const BadgeHolder = styled.div`
    position: absolute;
    top: 17px;
    left: 15px;
    z-index: 10;

    display: flex;
    gap: 5px;
`;

export const YatCardBadge = styled.div<{ $type: 'primary' | 'free' }>`
    color: #fff;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.24px;
    user-select: none;

    font-size: 10px;
    padding: 2px 6px;
    border-radius: 3px;

    cursor: pointer;

    ${({ $type }) => {
        if ($type === 'primary') {
            return css`
                background: radial-gradient(1781.76% 135.63% at 102.93% 143.75%, #000 0%, #31b2b2 100%);
                box-shadow:
                    0px 0px 30px 0px rgba(67, 197, 119, 0.6) inset,
                    0px 0px 24px 0px rgba(61, 241, 165, 0.35);
            `;
        }
        if ($type === 'free') {
            return css`
                background: radial-gradient(1781.76% 135.63% at 102.93% 143.75%, #000 0%, #5452d5 100%);
                box-shadow:
                    0px 0px 30px 0px rgba(177, 160, 247, 0.6) inset,
                    0px 0px 24px 0px rgba(177, 160, 247, 0.35);
            `;
        }
    }};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 12px;
        padding: 3px 8px;
        border-radius: 5px;
    }
`;
